import { FC } from 'react';
import { TextEllipsis } from 'components/text-ellipsis/text-ellipsis';
import s from './search-row-item.module.scss';

type OwnProps = {
  value: string;
  maxWidth?: string;
  className?: string;
  searchedValue: string;
  onClick?: (value: string) => void;
};

const SearchRowItem: FC<OwnProps> = ({ value = '', className = '', maxWidth = '100%', searchedValue = '', onClick }) => {
  const handleOnClick = () => {
    if (onClick) onClick(value);
  };

  return (
    <TextEllipsis
      maxWidth={maxWidth}
      tooltipTitle={value}
      searchedValue={searchedValue}
      className={`${s.row} ${className}`}
      data-is-clickable={Boolean(onClick)}
      onClick={handleOnClick}
    >
      {value}
    </TextEllipsis>
  );
};

export default SearchRowItem;
